<template>
  <!-- <h2>楓之谷R儲值流程</h2> -->
  <div class="thCss">
    <h3>ล็อกอินเกม / ลงทะเบียน</h3>
    <p>
      หน้าล็อกอินเกม / ลงทะเบียน ปัจจุบันนี้เกมรองรับ5วิธีในการล็อกอิน/ลงทะเบียน
      รวมถึงลงทะเบียนด่วน ล็อกอินโดยFacebook ล็อกอินโดยเบอร์โทรศัพท์
      ล็อกอินโดยบัญชีGoogleและอีเมล์ ลงทะเบียนด่วน กด[ลงทะเบียน]
      ป้อนบัญชีที่กำหนดเองและรหัสผ่านที่กำหนดเองด้วยตนเอง ป้อนรหัสผ่านอีกครั้ง
      คลิกปุ่ม[ลงทะเบียน]จะลงทะเบียนสำเร็จและสามารถเข้าสู้ระบบ
    </p>
    <img src="./../../../assets/info/th/1.png" />

    <h3>ศูนย์เติมเงิน</h3>
    <p>
      หลังจากเข้าเกมบน PC
      อัปเลเวลของตัวละครถึงLv.21แล้วสามารถปลดล็อก[ฟังก์ชั่นเติมเงิน]
      คลิกปุ่ม[แสดงมากกว่านี้]ในด้านซ้ายบน คลิก[โปรฯ]
      สามารถไปที่หน้าซื้อแพ็กโปรฯทันที
    </p>
    <img src="./../../../assets/info/th/2.png" />
    <p>
      1. คลิกแพ็กโปรฯที่ต้องการแล้วจะวาร์ปไป[ศูนย์เติมเงิน]
      ไปถึงขั้นตอนซื้อแพ็กโปรฯ
    </p>
    <p>2. ต่อไปต้องการยืนยันข้อมูลต่อไปนี้</p>
    <p>ข้อแรก เลือกภาษาที่ต้องการในมุมขวาบน</p>
    <p>เลือกเซิร์ฟเวอร์ที่ต้องการเติมงิน</p>
    <p>เลือกตัวละคร</p>
    <p>เลือกประเทศ/พื้นที่ที่ชำระเงิน</p>
    <p>เลือกวิธีชำระเงิน</p>
    <img src="./../../../assets/info/th/3.png" />

    <p>
      3.หลังจากเลือกวิธีชำระเงิน เลือกจำนวนเพชรสีที่ต้องการ
      ยืนยันข้อมูลของตัวละครซ้ำๆ ในหน้าต่างป๊อปอัป หลังจากยืนยันว่าถูกต้อง
      คลิก[ยืนยันการชำระเงิน]*（หลังจากเติมสำเร็จแล้วต้องการเข้าเกมกดรับก่อน5.00น.
      มิฉะนั้น ของที่ซื้ออาจสูญหาย)
    </p>
    <p>PayerMax-PayNow</p>
    <p>คลิกวิธีชำระเงิน PayerMax-PayNow เลือกแพ็กโปรฯที่โปรด</p>
    <img src="./../../../assets/info/th/4.png" />

    <p>
      4.ยืนยันข้อมูลถูกต้องแล้งวาร์ปไปวิธีชำระเงินที่เกี่ยวข้อง
      ชำระเงินตามข้อแนะนำจะสามารถทำการซื้อให้เสร็จสมบูรณ์
    </p>
    <img src="./../../../assets/info/th/5.png" />
    <p>TikiPay-Union pay</p>
    <p>คลิกวิธีชำระเงิน TikiPay-Unionbank เลือกแพ็กโปรฯที่โปรด</p>

    <img src="./../../../assets/info/th/6.png" />

    <p>
      ยืนยันข้อมูลถูกต้องแล้งวาร์ปไปหน้าการชำระเงินเดบิต กรอกอีเมล์
      เบอร์โทรศัพท์และชื่อให้ถูกต้อง แล้วคลิกซื้อ
    </p>
    <img src="./../../../assets/info/th/7.png" />

    <h3>หน้าฟังก์ชั่นอื่นๆ</h3>
    <p>1. ดาวน์โหลด</p>
    <p>
      ผู้เล่นคลิกปุ่ม[ติดตั้ง] หน้าเกมจะเปิดขึ้นในหน้าต่างแยกต่างหาก
      ในเวลาเดียวกันสามารถตรึงไว้ที่แถบงานของเดสก์ท็อป
      กดแล้วสามารถเข้าเกมได้ทันที และสามารถในหน้า[เริ่มต้อน]หาiconเพื่อเข้าเกม
    </p>
    <img src="./../../../assets/info/th/8.png" />
    <p>2. เว็บไซต์</p>
    <p>
      คลิก[เว็บไซต์] วาร์ปไปที่หน้าเว็บไซต์อย่างเป็นทางการ
      ตรวจดูข้อมูลเกมล่าสุดและสมบูรณ์ที่สุด!
    </p>
    <img src="./../../../assets/info/th/9.png" />
    <p>3.คั่นหน้า</p>
    <p>
      คลิก[คั่นหน้า]แล้ว จะถูกเพิ่มในรายการโปรดของเบราว์เซอร์
      และสามารถเปิดเกมในรายการโปรดได้โดยตรงหลังจากเปิดเบราว์เซอร์!
    </p>
    <img src="./../../../assets/info/th/11.png" />
    <p>4.บริการลูกค้า</p>
    <p>
      คลิก[บริการลูกค้า ] เข้าไปศูนย์บริการลูกค้า สามารถตรวจดู FAQ
      และค้นหาคำถามเพื่อดูวิธีแก้ไข หากว่าใน FAQ
      ไม่มีคำตอบที่สามารถแก้ไขปัญหาของคุณ
      คุณสามารถกรอกปัญหาตามความจริงของตนเองได้
    </p>
    <img src="./../../../assets/info/th/12.png" />
  </div>
</template>

<script>
export default {
  name: "RastarTh",
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
